// eslint-disable-next-line import/no-amd
define([
    'jquery',
    'underscore',
    'backbone',
    'commons',
    'react',
    'react-dom',
    '../../templates/edit_report_saved_view/tableselect_view.template',
    // './react-table-custom.css'
], ($, _, Backbone, commons, React, ReactDOM, html) => {
    const ComboBoxView = Backbone.View.extend({
        initialize(options) {
            this.options = options;
            this.render();
        },
        render() {
            const view = this;
            view.$el.spinner('on', { view });
            view.options.property.fetchPropertyValues({
                success() {
                    view.$el.html(_.template(html)({ $, property: view.options.property }));
                    view.renderElements(view.options.property);
                }
            });
        },
        convertData(property) {
            const data = [];
            _.each(property.get('propertyValues'), item => {
                data.push(item);
            });
            return data;
        },
        convertCols(property) {
            const columns = [];
            const values = property.get('propertyValues');
            _.each(values[0], (elem, key) => {
                columns.push({ Header: key, accessor: key });
            });
            return columns;
        },
        renderElements(property) {
            const view = this;
            let defaultValue = property.get('defaultValue');
            let value = property.get('value');
            if (value) {
                value = value.split(',');
            } else if (defaultValue) {
                defaultValue = defaultValue.split(',');
            }
            ReactDOM.render(
                <commons.TableSelector
                    data={this.convertData(property)}
                    columns={this.convertCols(property)}
                    callback={ids => { view.$el.find('.hiddenInputText').val(ids); }}
                    showPageSizeOptions={false}
                    defaultPageSize={5}
                />,
                document.getElementsByClassName('tableSelectHolder')[0]
            );
        },
        events: {},
    });

    return ComboBoxView;
});



// WEBPACK FOOTER //
// ./src/components/report/views/editReportSavedView/TableSelectView.js